export default __webpack_public_path__ + "static/media/longchamp6.e6fab6d1.jpg";